import { useState } from "react";
import { downloadInsightsDocument } from "./documentCard.utils";
import { toast } from "react-toastify";
import { getApiErrorMessage } from "../../../../../utils/getApiErrorMessage";

export const useDocumentCard = ({docName, docLink}: {docName: string, docLink: string | null | undefined}) => {
    const [isDownloading, setIsDownloading] = useState(false);
    
    const handleDownload = async () => {
        if(!docLink || isDownloading) return;

        setIsDownloading(true);
        try {
            await downloadInsightsDocument(docLink, docName);
        } catch (error) {
            toast.error(getApiErrorMessage(error, `Failed to download ${docName}`));
        } finally {
            setIsDownloading(false);
        }
    }

    return {
        isDownloading,
        handleDownload
    }
}